import { List, TextField, SimpleList, Datagrid, TextInput, ArrayField, SingleFieldList, ChipField } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT, PERMISSIONS } from "utils/constants";
import { PermissionsExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import EditRolesDialog from "./EditRolesDialog";

const ListPermissions = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const canEditRoles = checkPermission(getPermissions(), permissions.canAttachPermissionsToRoles);

  const filters = [
    <TextInput
      source="name"
      label="Име"
      alwaysOn
    />,
    <TextInput
      source="description"
      label="Описание"
      alwaysOn
    />,
  ];

  return (
    <List
      title="Права"
      sx={settings.style.expandStyle}
      actions={<ExportXlsButton exporter={PermissionsExporter(PERMISSIONS)} />}
      filters={filters}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                { label: "Име", value: record.name },
                { label: "Описание", value: record.description },
                {
                  label: "Роли",
                  value: (
                    <ArrayField
                      source="roles"
                      record={record}
                    >
                      <SingleFieldList linkType={false}>
                        <ChipField source="name" />
                      </SingleFieldList>
                    </ArrayField>
                  ),
                },
              ]}
            />
          )}
          tertiaryText={() => canEditRoles && <EditRolesDialog />}
          // tertiaryText={() => ({
          //   /* TODO - this is not ready on backend */
          //   /* {checkPermission(userPermissions, permissions.canChangePermissionsDescription) && <EditButton />} */
          // })}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="name"
            label="Име"
            sortable={false}
          />
          <TextField
            source="description"
            label="Описание"
            sortable={false}
          />
          <ArrayField
            source="roles"
            label="Роли"
            sortable={false}
          >
            <SingleFieldList linkType={false}>
              <ChipField source="name" />
            </SingleFieldList>
          </ArrayField>
          {canEditRoles && <EditRolesDialog />}
          {/* TODO - this is not ready on backend */}
          {/* {checkPermission(userPermissions, permissions.canChangePermissionsDescription) && <EditButton />} */}
        </Datagrid>
      )}
    </List>
  );
};
export default ListPermissions;
